export default __webpack_public_path__ + "static/media/goshen24.656dcbd6.jpg";